import { Fragment } from 'react';
import type { TimelineNode } from './interfaces';
import {
  ReasoningBlockView,
  ScopeBlockView,
  ToolCallBlockView,
  MessageBlockView,
  ErrorBlockView,
} from './Blocks';
import { getTimelineNodeKey } from './utils.timeline';

export function AgentProgressTimelineBlock({ node }: { node: TimelineNode }) {
  switch (node.kind) {
    case 'reasoning':
      return <ReasoningBlockView node={node} />;

    case 'scope':
      if (node.block.depth === 0) {
        return (
          <Fragment>
            {node.children.map((child) => (
              <AgentProgressTimelineBlock key={getTimelineNodeKey(child)} node={child} />
            ))}
          </Fragment>
        );
      }
      return (
        <ScopeBlockView block={node.block}>
          {node.children.map((child) => (
            <AgentProgressTimelineBlock key={getTimelineNodeKey(child)} node={child} />
          ))}
        </ScopeBlockView>
      );

    case 'tool_call':
      return (
        <ToolCallBlockView block={node.block}>
          {node.children.map((child) => (
            <AgentProgressTimelineBlock key={getTimelineNodeKey(child)} node={child} />
          ))}
        </ToolCallBlockView>
      );

    case 'message':
      return <MessageBlockView block={node.block} />;

    case 'error':
      return <ErrorBlockView block={node.block} />;

    default:
      return null;
  }
}
